if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {

    constructor() {
      super();
      this.handleProductCardSwatchClick();
    }

    handleInsideLinkClick = (event) => {
      event.preventDefault();
    }

    fetchProduct(event) {
      event.preventDefault();

      const productUrl = event.target.dataset.productUrl;
      if (!productUrl) {
        console.warn('No product URL found on swatch');
        return;
      }

      // Extract product handle from URL, e.g. "/products/your-handle"
      const handleMatch = productUrl.match(/\/products\/([a-z0-9\-]+)/);
      if (!handleMatch || !handleMatch[1]) {
        console.warn('Could not parse product handle from URL:', productUrl);
        return;
      }
      const productHandle = handleMatch[1];

      // Fetch the section using Section Rendering API
      fetch(`/products/${productHandle}?sections=card-product--swatches`)
        .then(response => {
          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then(data => {
          const newHtml = data['card-product--swatches'];
          if (newHtml) {
            this.innerHTML = newHtml;
            this.handleProductCardSwatchClick();
          } else {
            console.warn('No card-product--swatches section returned in response');
          }
        })
        .catch(error => {
          console.error('Error fetching product card:', error);
        })
        .finally(() => {
          // Refresh Yotpo star rating widgets, if present
          if (window.Yotpo && window.Yotpo.API) {
            const api = new window.Yotpo.API(window.yotpo);
            if (api) api.refreshWidgets();
          }

          // Dispatch event for wishlist button refresh
          document.dispatchEvent(new CustomEvent('swym:product-card-loaded'));
        });
    }

    handleProductCardSwatchClick() {
      const swatches = this.querySelectorAll('product-group product-group-swatch');
      swatches.forEach((swatch) => {
        swatch.addEventListener('click', this.fetchProduct.bind(this));
        const link = swatch.querySelector('a.product-group--item');
        if (link) {
          link.classList.add('js-load');
          link.addEventListener('click', this.handleInsideLinkClick);
        }
      });
    }

  }

  customElements.define('product-card', ProductCard);
}
